<template>
  <div>
    <el-card>
      <template #header>
        <content-header/>
      </template>
      <el-form>
        <div class="header-button">
          <div class="searchForm">
            <el-form-item label="月份：" label-width="80px">
              <el-date-picker
                v-model="monthVal"
                type="month"
                placeholder="选择月"
                @change="selectChange"
              />
            </el-form-item>
            <el-form-item label="工单类型：">
              <el-select
                v-model="work_order_type"
                class="limitwidth"
                @change="selectChange"
                placeholder="请选择类型"
              >
                <el-option
                  v-for="item in workOrderTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>

          <div class="selections">
            <el-form-item label="地勤人员:">
              <el-select v-model="worker_id" @change="selectChange" placeholder="请选择人员">
                <el-option
                  v-for="item in usersOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <el-row>
        <line-chart :chart-data="workOrdersData"/>
      </el-row>

      <el-row style="margin-bottom:25px;">
        <p class="todo-title">月工单统计明细</p>
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            label="工单类型"
          >
            <template slot-scope="scope">
              {{ scope.row.type_name }}
            </template>
          </el-table-column>
          <el-table-column
            label="完成数量"
          >
            <template slot-scope="scope">
              {{ scope.row.type_total_sum }}
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <HorizontalBarChart :chart-data="workOrdersByTypeData"/>
      </el-row>
      <el-row>
        <p class="todo-title">地勤绩效汇总</p>
        <el-table
          :data="tableWorkOrderByworker"
          style="width: 100%"
        >
          <el-table-column
            label="人员"
          >
            <template slot-scope="scope">
              {{ scope.row.worker_over == null ?'系统' : scope.row.worker_over.name }}
            </template>
          </el-table-column>
          <el-table-column
            label="完成数量"
          >
            <template slot-scope="scope">
              {{ scope.row.type_total_sum }}
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { getWorkers, getWorkOrderChart } from '@/api/workers'
import { getworkOrderTypes } from '@/api/work-order'
import LineChart from './components/LineChart'
import HorizontalBarChart from './components/HorizontalBarChart'

export default {
  name: 'Achievements',
  components: {
    LineChart,
    HorizontalBarChart,
  },
  data() {
    return {
      monthVal: '',
      usersOptions: [],
      workOrderTypes: [],
      worker_id: '',
      work_order_type: '',
      workOrdersData: {
        expectedData: {
          data: [],
          date: [],
        },
      },
      workOrdersByTypeData: {
        expectedData: {
          dataName: [],
          yData: [],
        },
      },
      tableData: [],
      tableWorkOrderByworker: [],
    }
  },
  async created() {
    const [{ data: workers }, { data: workOrderTypes }] = await Promise.all([
      getWorkers({ all: 1 }),
      getworkOrderTypes(),
    ])
    this.usersOptions = []
    this.usersOptions.push({ value: '', label: '全部' })
    workers.map(e => {
      this.usersOptions.push({ value: e.id, label: e.name })
    })
    this.workOrderTypes = []
    this.workOrderTypes.push({ id: '', name: '全部' })
    workOrderTypes.map(e => {
      this.workOrderTypes.push({ id: e.id, name: e.name })
    })
    if (this.$route.query.worker_id !== undefined) {
      this.worker_id = parseInt(this.$route.query.worker_id)
    }
    this.selectChange()
  },
  methods: {
    async selectChange() {
      // console.log(this.monthVal)
      const [{ data }] = await Promise.all([
        getWorkOrderChart({ monthVal: this.monthVal, worker_id: this.worker_id, work_order_type: this.work_order_type }),
      ])
      this.workOrdersData.expectedData.data = []
      this.workOrdersData.expectedData.date = []
      data.workOrder.map(i => {
        this.workOrdersData.expectedData.data.push(i.value)
        this.workOrdersData.expectedData.date.push(i.date)
      })
      this.workOrdersByTypeData.expectedData.dataName = []
      this.workOrdersByTypeData.expectedData.yData = []
      data.workOrderByTypes.map(i => {
        // console.log(i.type_name)
        this.workOrdersByTypeData.expectedData.dataName.push(i.type_name)
        this.workOrdersByTypeData.expectedData.yData.push(i.type_total_sum)
      })

      this.tableData = data.workOrderByTypes
      this.tableWorkOrderByworker = data.workOrderByworker
    },
  },
}
</script>
<style lang="scss" scope>
.header-button{
  display:flex;
  justify-content: space-between;
  .searchForm{
    display:flex;
    justify-content: space-around;
    flex-direction: row;
  }
  .selections{
      display: inline-block;
      margin-right:10px
    }
}
.todo-title{
      color: #36a3f7;
      font-size: 1.2rem;
      // padding-top: 15px;
    }
.limitwidth {
        width: 80%;
        margin-right: 10px;
    }
</style>
